import * as React from 'react'
import styled from 'styled-components'
import * as constants from 'static/constants'
import ClassNames from 'classnames'
import I18n from 'core/i18n'
import SvgIcon from 'components/atoms/SvgIcon'
import { IconName } from '../../../types/icon-names'

interface IProps {
  type: 'skill' | 'tour_skill'
  skills: Array<{
    id: number
    name: string
    disabled?: boolean
    level?: number
  }>
}

const MAX_COUNT = 5

const SkillContainer: React.VFC<IProps> = React.memo(({ type, skills }) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [displayCount, setDisplayCount] = React.useState<number>(MAX_COUNT)

  return (
    <SkillContainerWrapper>
      {skills.slice(0, displayCount).map(skill => {
        let iconName: IconName = 'tag'
        if (type === 'skill') {
          iconName = 'tag'
        } else if (type === 'tour_skill') {
          iconName = `skill-level-rank-${skill.level}` as IconName
        }
        return (
          <div
            className={ClassNames(type, {
              disabled: skill.disabled,
              [`rank-${skill.level}`]: skill.level,
            })}
            key={`${type}-${skill.id}`}
            aria-label="skill tag"
          >
            <SvgIcon name={iconName} className="icon" ariaHidden={true} role="presentation" />
            {skill.name}
            {skill.disabled && (
              <SvgIcon
                name="pause_circle_filled"
                className="disabled-icon"
                ariaHidden={true}
                role="presentation"
              />
            )}
          </div>
        )
      })}
      {skills.length > 5 && (
        <div
          className="showMore"
          onClick={() => {
            setDisplayCount(isOpen ? MAX_COUNT : skills.length)
            setIsOpen(!isOpen)
          }}
        >
          {isOpen ? I18n.t('generic.close') : I18n.t('generic.show_all')}
        </div>
      )}
    </SkillContainerWrapper>
  )
})

const SkillContainerWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  div {
    line-height: 16px;
    padding: 4px 8px 4px 4px;
    color: ${constants.COLORS.black};
    font-size: 11px;
    border-radius: 4px;
    word-break: break-all;
    .icon {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .skill {
    background-color: ${constants.COLORS.successBG2};
    .icon {
      color: ${constants.COLORS.primary};
    }
  }

  .tour_skill {
    background-color: ${constants.COLORS.background2};
    color: ${constants.COLORS.black};

    .icon {
      color: ${constants.COLORS.primary};
    }

    &.rank-1 .icon {
      color: ${constants.COLORS.danger};
    }
    &.rank-2 .icon,
    &.rank-3 .icon {
      color: ${constants.COLORS.info2};
    }
    &.rank-4 .icon {
      color: ${constants.COLORS.primary};
    }
    &.rank-5 .icon {
      color: ${constants.COLORS.info3};
    }

    &.disabled {
      background-color: ${constants.COLORS.divider2};
      color: ${constants.COLORS.subText};
      .icon {
        color: ${constants.COLORS.subText};
      }
      .disabled-icon {
        width: 16px;
        height: 16px;
        margin-left: 4px;
      }
    }
  }
  .showMore {
    color: ${constants.COLORS.primary};
    font-size: 11px;
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`

export default SkillContainer
